/* eslint-disable @typescript-eslint/naming-convention */
export enum SkinProblemFrequency {
	"定期的に肌荒れを起こすことがある（生理前・季節の変わり目などに起こす肌荒れ）",
	"一時的な肌荒れを起こすことがある（ストレス、食生活の乱れなどによる肌荒れ）",
	"基本的に肌荒れはしない",
}
